import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import conf from "../../../config.js";

export default class EditJadwal extends React.Component {
    constructor(props) {
        super(props);
        const now = new Date();
        const month = now.getMonth() + 1;
        const year = now.getFullYear();
        const defaultTA = month >= 7 ? `${year} / ${year + 1}` : `${year - 1} / ${year}`;
        const defaultSem = month >= 7 ? "1" : "2";

        // Read query params if any (?rombel=...&versi=...)
        const searchParams = new URLSearchParams(window.location.search);
        const queryRombel = searchParams.get("rombel") || "";
        const queryVersi = searchParams.get("versi") || "";

        this.state = {
            institusi_id: "",
            tahun_ajaran: defaultTA,
            semester: defaultSem,
            kurikulum: "merdeka",
            loading: true,
            saving: false,
            swapping: false,
            deleting: false,

            // Schedule & Config data
            jadwal: [],
            all_jadwal: [],
            waktu_list: [],
            waktu_per_tingkat: {},
            rombel_list: [],
            selected_rombel: queryRombel,
            versi_list: [],
            selected_versi: queryVersi,
            penugasan_list: [],
            guru_list: [],
            bentrokan_list: [],

            // Modal: Edit / Isi Slot
            show_edit_modal: false,
            edit_slot: null, // { id, hari, jam_ke, rombel_nama, mapel_nama, guru_nama, ruang, keterangan, pindah_hari, pindah_jam }
            is_move_slot: false,
            bentrokan_error: null,

            // Modal: Swap
            show_swap_modal: false,
            swap_slot_a: null,
            swap_slot_b: null,
            swap_target_rombel: "",
            swap_bentrokan_error: null,

            // Visual Swap Mode on Table
            is_visual_swap: false,
            visual_swap_source: null,

            // Modal: Confirm Delete
            show_delete_confirm: false,
            delete_target_slot: null,

            // View Mode & Day Tabs
            active_day_tab: "all", // "all", "1", "2", "3", "4", "5", "6"
            view_mode: "matrix", // "matrix" as default
            jadwal_by_hari: {},

            // Toast Alert
            toast: null, // { message, type: 'success' | 'error' | 'warning' }
        };
    }

    componentDidMount() {
        this.getSession();
    }

    getSession() {
        const tokenApi = "Bearer " + localStorage.getItem("token");
        axios.post(`${conf.uri_backend}api/v1/auth/sso/user`, { token: localStorage.getItem("token") }, { headers: { Authorization: tokenApi } })
            .then((res) => {
                const npsn = res.data.access_to;
                axios.get(`${conf.uri_backend}api/v1/select-institusi/${npsn}`, { headers: { Authorization: tokenApi } })
                    .then((instRes) => {
                        this.setState({ institusi_id: instRes.data.id }, () => {
                            this.initData();
                        });
                    })
                    .catch(() => {
                        this.setState({ institusi_id: npsn }, () => {
                            this.initData();
                        });
                    });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    getApiHeaders() {
        return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } };
    }

    getBaseParams() {
        return `institusi=${this.state.institusi_id}&tahun_ajaran=${this.state.tahun_ajaran}&semester=${this.state.semester}&kurikulum=${this.state.kurikulum}`;
    }

    getTahunAjaranOptions() {
        const now = new Date();
        const year = now.getFullYear();
        const options = [];
        for (let y = year + 1; y >= year - 3; y--) {
            options.push(`${y} / ${y + 1}`);
        }
        return options;
    }

    showToast(message, type = "success") {
        this.setState({ toast: { message, type } });
        if (this.toastTimeout) clearTimeout(this.toastTimeout);
        this.toastTimeout = setTimeout(() => {
            this.setState({ toast: null });
        }, 4000);
    }

    initData() {
        this.loadVersi();
        this.loadWaktu();
        this.loadPenugasan();
        this.loadGuruList();
        this.loadJadwal();
    }

    onFilterChange(partial) {
        this.setState({
            ...partial,
            selected_rombel: "",
            selected_versi: "",
            jadwal: [],
            all_jadwal: [],
            rombel_list: [],
            versi_list: [],
            waktu_list: [],
            loading: true,
            bentrokan_error: null,
            is_visual_swap: false,
            visual_swap_source: null,
            swap_target_rombel: "",
        }, () => {
            this.initData();
        });
    }

    loadVersi() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/versi?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ versi_list: res.data.data || [] });
                }
            })
            .catch(() => {});
    }

    loadWaktu() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/waktu?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    const allData = res.data.data || [];
                    const perTingkat = {};
                    allData.forEach(w => {
                        const t = w.tingkat || '_shared';
                        if (!perTingkat[t]) perTingkat[t] = [];
                        perTingkat[t].push(w);
                    });
                    const seen = {};
                    const flatData = allData.filter(w => {
                        const key = `${w.hari}_${w.jam_ke || ''}_${w.waktu_mulai || ''}_${w.tipe || ''}_${w.urutan || ''}`;
                        if (seen[key]) return false;
                        seen[key] = true;
                        return true;
                    });
                    this.setState({ waktu_list: flatData, waktu_per_tingkat: perTingkat });
                }
            })
            .catch(() => {});
    }

    loadPenugasan() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/penugasan?${this.getBaseParams()}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ penugasan_list: res.data.data || [] });
                }
            })
            .catch(() => {});
    }

    loadGuruList() {
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/data/guru?institusi=${this.state.institusi_id}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ guru_list: res.data.data || [] });
                }
            })
            .catch(() => {});
    }

    loadBentrokan() {
        const versiParam = this.state.selected_versi ? `&versi_id=${this.state.selected_versi}` : "";
        axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/bentrokan?${this.getBaseParams()}${versiParam}`, this.getApiHeaders())
            .then((res) => {
                if (res.data.status) {
                    this.setState({ bentrokan_list: res.data.data || [] });
                }
            })
            .catch(() => {});
    }

    getActiveDays() {
        const { waktu_list } = this.state;
        const days = [...new Set((waktu_list || []).map(w => Number(w.hari)))].filter(h => h > 0).sort((a, b) => a - b);
        return days.length > 0 ? days : [1, 2, 3, 4, 5];
    }

    loadJadwal() {
        const versiParam = this.state.selected_versi ? `&versi_id=${this.state.selected_versi}` : "";
        const rombelParam = this.state.selected_rombel ? `&rombel_nama=${encodeURIComponent(this.state.selected_rombel)}` : "";

        Promise.all([
            axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/rombel?${this.getBaseParams()}${versiParam}${rombelParam}`, this.getApiHeaders()),
            axios.get(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/all?${this.getBaseParams()}${versiParam}`, this.getApiHeaders()).catch(() => ({ data: { status: false, data: [] } }))
        ])
            .then(([resRombel, resAll]) => {
                if (resRombel.data && resRombel.data.status) {
                    const raw = resRombel.data.data;
                    const byHari = (raw && typeof raw === 'object' && !Array.isArray(raw)) ? raw : {};
                    // Filter: real schedules that have mapel_nama
                    const fromRombel = (Array.isArray(raw) ? raw : Object.values(byHari).flat()).filter(j => j && j.mapel_nama);

                    const rombels = resRombel.data.rombel_list || [];
                    let newRombel = this.state.selected_rombel;
                    if (!newRombel && rombels.length > 0) {
                        newRombel = rombels[0].rombel_nama;
                    }

                    const allJadwalData = (resAll.data && resAll.data.status && Array.isArray(resAll.data.data))
                        ? resAll.data.data.filter(j => j && j.mapel_nama)
                        : [];

                    // Merge any records from jadwal/all for the selected rombel so no schedule record is ever hidden
                    const allForRombel = allJadwalData.filter(j => j && j.rombel_nama === newRombel);

                    const mapById = {};
                    fromRombel.forEach(j => { if (j && j.id) mapById[j.id] = j; });
                    allForRombel.forEach(j => {
                        if (j && j.id) {
                            if (!mapById[j.id]) {
                                mapById[j.id] = j;
                                fromRombel.push(j);
                            } else {
                                if (!mapById[j.id].keterangan && j.keterangan) {
                                    mapById[j.id].keterangan = j.keterangan;
                                }
                            }
                        }
                    });

                    this.setState({
                        jadwal: fromRombel,
                        all_jadwal: allJadwalData,
                        jadwal_by_hari: byHari,
                        rombel_list: rombels,
                        selected_rombel: newRombel,
                        loading: false
                    }, () => {
                        this.loadBentrokan();
                        // If rombel changed to default and query was empty, re-filter if needed
                        if (!this.state.selected_rombel && newRombel) {
                            this.setState({ selected_rombel: newRombel }, () => this.loadJadwal());
                        }
                    });
                } else {
                    this.setState({ jadwal: [], all_jadwal: [], jadwal_by_hari: {}, loading: false });
                }
            })
            .catch(() => this.setState({ loading: false }));
    }

    renderHariLabel(h) {
        return { 1: "Senin", 2: "Selasa", 3: "Rabu", 4: "Kamis", 5: "Jumat", 6: "Sabtu", 7: "Minggu" }[h] || `Hari ${h}`;
    }

    getWaktuByHari(tingkat) {
        const { waktu_list, waktu_per_tingkat } = this.state;
        let sourceList = waktu_list;
        if (tingkat && waktu_per_tingkat) {
            if (waktu_per_tingkat[tingkat]) {
                sourceList = waktu_per_tingkat[tingkat];
            } else if (waktu_per_tingkat['_shared']) {
                sourceList = waktu_per_tingkat['_shared'];
            }
        }
        const waktuByHari = {};
        sourceList.forEach((w) => {
            const h = Number(w.hari);
            if (!waktuByHari[h]) waktuByHari[h] = [];
            waktuByHari[h].push(w);
        });
        Object.keys(waktuByHari).forEach(h => {
            waktuByHari[h].sort((a, b) => {
                if (a.urutan !== undefined && b.urutan !== undefined) return a.urutan - b.urutan;
                return (Number(a.jam_ke) || 0) - (Number(b.jam_ke) || 0);
            });
        });
        return waktuByHari;
    }

    getSlotsForRombel(rombelNama) {
        const { all_jadwal, jadwal, selected_rombel, rombel_list } = this.state;
        if (!rombelNama) return [];

        const targetRombelInfo = (rombel_list || []).find(r => r.rombel_nama === rombelNama);
        const targetTingkat = targetRombelInfo ? targetRombelInfo.kelas : null;
        const waktuByHari = this.getWaktuByHari(targetTingkat);
        const activeDays = this.getActiveDays();

        // Source schedule items for this rombel
        const sourceSchedules = (rombelNama === selected_rombel)
            ? jadwal
            : (all_jadwal || []).filter(j => j && j.rombel_nama === rombelNama);

        const scheduleMap = {};
        sourceSchedules.forEach(j => {
            if (j && j.mapel_nama) {
                scheduleMap[`${Number(j.hari)}_${Number(j.jam_ke)}`] = j;
            }
        });

        const result = [];
        activeDays.forEach(h => {
            const dayWaktuSlots = (waktuByHari[h] || []).filter(w => !w.is_istirahat && Number(w.jam_ke) > 0);
            const sortedSlots = [...dayWaktuSlots].sort((a, b) => (Number(a.jam_ke) || 0) - (Number(b.jam_ke) || 0));

            sortedSlots.forEach(w => {
                const j = Number(w.jam_ke);
                const fmtTime = (t) => t ? t.substring(0, 5) : '';
                const waktuLabel = (w.waktu_mulai && w.waktu_selesai) ? `${fmtTime(w.waktu_mulai)} - ${fmtTime(w.waktu_selesai)}` : '';
                const cell = scheduleMap[`${h}_${j}`] || null;

                result.push({
                    hari: h,
                    jam_ke: j,
                    waktuLabel: waktuLabel,
                    rombel_nama: rombelNama,
                    jadwal: cell,
                    is_filled: Boolean(cell && cell.mapel_nama),
                    mapel_nama: cell ? cell.mapel_nama : "",
                    guru_nama: cell ? cell.guru_nama : "",
                    id: cell ? cell.id : null,
                    versi_id: cell ? cell.versi_id : null,
                });
            });
        });

        return result;
    }

    // ========================================================
    //  MODAL: EDIT / ISI SLOT
    // ========================================================
    openEditModal(cellData, hari, jamKe, waktuLabel = "") {
        const { selected_rombel, selected_versi, versi_list } = this.state;
        const versiId = cellData?.versi_id || selected_versi || (versi_list.find(v => v.is_aktif)?.id) || "";

        if (cellData && cellData.id) {
            // Edit existing slot
            this.setState({
                show_edit_modal: true,
                is_move_slot: false,
                bentrokan_error: null,
                edit_slot: {
                    id: cellData.id,
                    versi_id: versiId,
                    rombel_nama: cellData.rombel_nama || selected_rombel,
                    kelas: cellData.kelas || "",
                    hari: cellData.hari || hari,
                    jam_ke: cellData.jam_ke || jamKe,
                    target_hari: cellData.hari || hari,
                    target_jam_ke: cellData.jam_ke || jamKe,
                    mapel_nama: cellData.mapel_nama || "",
                    mapel_kode: cellData.mapel_kode || "",
                    guru_nama: cellData.guru_nama || "",
                    guru_nip: cellData.guru_nip || "",
                    guru_kode: cellData.guru_kode || "",
                    ruang: cellData.ruang || "",
                    keterangan: cellData.keterangan || "",
                    waktuLabel: waktuLabel || `${cellData.jam_mulai?.substring(0, 5)} - ${cellData.jam_selesai?.substring(0, 5)}`,
                }
            });
        } else {
            // Fill empty slot
            this.setState({
                show_edit_modal: true,
                is_move_slot: false,
                bentrokan_error: null,
                edit_slot: {
                    id: null,
                    versi_id: versiId,
                    rombel_nama: selected_rombel,
                    kelas: "",
                    hari: hari,
                    jam_ke: jamKe,
                    target_hari: hari,
                    target_jam_ke: jamKe,
                    mapel_nama: "",
                    mapel_kode: "",
                    guru_nama: "",
                    guru_nip: "",
                    guru_kode: "",
                    ruang: "",
                    keterangan: "",
                    waktuLabel: waktuLabel,
                }
            });
        }
    }

    closeEditModal() {
        this.setState({
            show_edit_modal: false,
            edit_slot: null,
            bentrokan_error: null,
            is_move_slot: false,
        });
    }

    onSelectPenugasan(e) {
        const val = e.target.value;
        if (!val) return;
        const [mapelNama, guruNama] = val.split("|||");
        const { penugasan_list, selected_rombel } = this.state;
        const p = penugasan_list.find(item => item.rombel_nama === selected_rombel && item.mapel_nama === mapelNama && item.guru_nama === guruNama);
        if (p) {
            this.setState(prevState => ({
                edit_slot: {
                    ...prevState.edit_slot,
                    mapel_nama: p.mapel_nama,
                    mapel_kode: p.mapel_kode || "",
                    guru_nama: p.guru_nama,
                    guru_nip: p.guru_nip || "",
                    kelas: p.kelas || prevState.edit_slot.kelas
                }
            }));
        }
    }

    handleSaveSlot(force = false) {
        const { edit_slot, institusi_id, tahun_ajaran, semester, kurikulum, selected_versi, selected_rombel, versi_list, is_move_slot } = this.state;
        if (!edit_slot) return;

        if (!edit_slot.mapel_nama || !edit_slot.guru_nama) {
            this.showToast("Mata Pelajaran dan Guru Pengajar wajib diisi.", "warning");
            return;
        }

        const versiId = edit_slot.versi_id || selected_versi || (versi_list.find(v => v.is_aktif)?.id);
        const targetHari = is_move_slot ? Number(edit_slot.target_hari) : Number(edit_slot.hari);
        const targetJamKe = is_move_slot ? Number(edit_slot.target_jam_ke) : Number(edit_slot.jam_ke);

        const payload = {
            id: edit_slot.id || undefined,
            versi_id: versiId,
            institusi: institusi_id,
            institusi_id: institusi_id,
            tahun_ajaran: tahun_ajaran,
            semester: semester,
            kurikulum: kurikulum,
            rombel_nama: edit_slot.rombel_nama || selected_rombel,
            kelas: edit_slot.kelas || undefined,
            hari: targetHari,
            jam_ke: targetJamKe,
            mapel_nama: edit_slot.mapel_nama,
            mapel_kode: edit_slot.mapel_kode || undefined,
            guru_nama: edit_slot.guru_nama,
            guru_nip: edit_slot.guru_nip || undefined,
            guru_kode: edit_slot.guru_kode || undefined,
            ruang: edit_slot.ruang || null,
            keterangan: edit_slot.keterangan || null,
            force: !!force
        };

        this.setState({ saving: true, bentrokan_error: null });

        axios.post(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/update-slot`, payload, this.getApiHeaders())
            .then((res) => {
                this.setState({ saving: false });
                if (res.data.status) {
                    this.showToast(res.data.message || "Slot jadwal berhasil disimpan!", "success");
                    this.closeEditModal();
                    this.loadJadwal();
                    this.loadBentrokan();
                } else if (res.data.is_bentrok) {
                    this.setState({
                        bentrokan_error: {
                            message: res.data.message || "Terdeteksi bentrokan jadwal.",
                            bentrokan: res.data.bentrokan || []
                        }
                    });
                } else {
                    this.showToast(res.data.message || "Gagal menyimpan slot.", "error");
                }
            })
            .catch((err) => {
                this.setState({ saving: false });
                const data = err.response?.data;
                if (data?.is_bentrok) {
                    this.setState({
                        bentrokan_error: {
                            message: data.message || "Terdeteksi bentrokan jadwal.",
                            bentrokan: data.bentrokan || []
                        }
                    });
                } else {
                    this.showToast(data?.message || err.message || "Terjadi kesalahan saat menyimpan slot.", "error");
                }
            });
    }

    // ========================================================
    //  DELETE / KOSONGKAN SLOT
    // ========================================================
    promptDeleteSlot(slot) {
        this.setState({
            show_delete_confirm: true,
            delete_target_slot: slot,
        });
    }

    handleExecuteDelete() {
        const { delete_target_slot, selected_versi, versi_list, selected_rombel } = this.state;
        if (!delete_target_slot) return;

        const versiId = delete_target_slot.versi_id || selected_versi || (versi_list.find(v => v.is_aktif)?.id);

        const payload = {
            id: delete_target_slot.id || undefined,
            versi_id: versiId,
            rombel_nama: delete_target_slot.rombel_nama || selected_rombel,
            hari: Number(delete_target_slot.hari),
            jam_ke: Number(delete_target_slot.jam_ke)
        };

        this.setState({ deleting: true });

        axios.post(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/delete-slot`, payload, this.getApiHeaders())
            .then((res) => {
                this.setState({ deleting: false, show_delete_confirm: false, delete_target_slot: null });
                if (res.data.status) {
                    this.showToast(res.data.message || "Slot jadwal berhasil dikosongkan.", "success");
                    this.closeEditModal();
                    this.loadJadwal();
                    this.loadBentrokan();
                } else {
                    this.showToast(res.data.message || "Gagal mengosongkan slot.", "error");
                }
            })
            .catch((err) => {
                this.setState({ deleting: false });
                this.showToast(err.response?.data?.message || err.message || "Gagal mengosongkan slot.", "error");
            });
    }

    // ========================================================
    //  SWAP SLOT (TUKAR POSISI)
    // ========================================================
    toggleVisualSwap() {
        if (this.state.is_visual_swap) {
            this.cancelVisualSwap();
        } else {
            this.setState({
                is_visual_swap: true,
                visual_swap_source: null,
            });
            this.showToast("Mode Tukar Aktif: Klik slot pertama di tabel sebagai sumber.", "warning");
        }
    }

    cancelVisualSwap() {
        this.setState({
            is_visual_swap: false,
            visual_swap_source: null,
        });
    }

    onCellClick(firstCell, hari, jamKe, waktuLabel) {
        const { is_visual_swap, visual_swap_source, selected_rombel, selected_versi, versi_list } = this.state;
        const targetRombel = firstCell?.rombel_nama || selected_rombel;
        const versiId = firstCell?.versi_id || selected_versi || (versi_list.find(v => v.is_aktif)?.id);

        // Visual Swap mode active
        if (is_visual_swap) {
            const currentSlot = {
                id: firstCell?.id || null,
                versi_id: versiId,
                rombel_nama: targetRombel,
                hari: hari,
                jam_ke: jamKe,
                mapel_nama: firstCell?.mapel_nama || "",
                guru_nama: firstCell?.guru_nama || "",
                waktuLabel: waktuLabel
            };

            if (!visual_swap_source) {
                // Step 1: Pick source slot
                this.setState({ visual_swap_source: currentSlot });
                this.showToast(`Slot 1 dipilih: [${currentSlot.rombel_nama}] ${this.renderHariLabel(hari)} Jam ke-${jamKe}. Sekarang klik slot kedua (tujuan), bisa di kelas ini atau ganti kelas!`, "success");
            } else {
                // Step 2: Pick target slot (must be different slot)
                if (visual_swap_source.rombel_nama === currentSlot.rombel_nama &&
                    Number(visual_swap_source.hari) === Number(hari) &&
                    Number(visual_swap_source.jam_ke) === Number(jamKe)) {
                    this.showToast("Pilih slot lain yang berbeda untuk ditukar.", "warning");
                    return;
                }

                // Open Swap Confirmation Modal
                this.setState({
                    show_swap_modal: true,
                    swap_slot_a: visual_swap_source,
                    swap_slot_b: currentSlot,
                    swap_target_rombel: currentSlot.rombel_nama,
                    swap_bentrokan_error: null,
                });
            }
            return;
        }

        // Normal mode: Open edit modal
        this.openEditModal(firstCell, hari, jamKe, waktuLabel);
    }

    openSwapModalFromEdit() {
        if (!this.state.edit_slot) return;
        const slotA = { ...this.state.edit_slot };
        this.closeEditModal();
        this.setState({
            show_swap_modal: true,
            swap_slot_a: slotA,
            swap_target_rombel: slotA.rombel_nama || this.state.selected_rombel,
            swap_slot_b: null,
            swap_bentrokan_error: null,
        });
    }

    closeSwapModal() {
        this.setState({
            show_swap_modal: false,
            swap_slot_a: null,
            swap_slot_b: null,
            swap_target_rombel: "",
            swap_bentrokan_error: null,
        });
    }

    handleExecuteSwap(force = false) {
        const { swap_slot_a, swap_slot_b, institusi_id, selected_versi, versi_list } = this.state;
        if (!swap_slot_a || !swap_slot_b) {
            this.showToast("Pilih slot tujuan untuk ditukar.", "warning");
            return;
        }

        const versiId = swap_slot_a.versi_id || swap_slot_b.versi_id || selected_versi || (versi_list.find(v => v.is_aktif)?.id);

        const payload = {
            versi_id: versiId,
            institusi: institusi_id,
            force: !!force,
            slot_a_id: swap_slot_a.id || undefined,
            slot_b_id: swap_slot_b.id || undefined,
            slot_a: {
                id: swap_slot_a.id || null,
                hari: Number(swap_slot_a.hari),
                jam_ke: Number(swap_slot_a.jam_ke),
                rombel_nama: swap_slot_a.rombel_nama
            },
            slot_b: {
                id: swap_slot_b.id || null,
                hari: Number(swap_slot_b.hari),
                jam_ke: Number(swap_slot_b.jam_ke),
                rombel_nama: swap_slot_b.rombel_nama
            }
        };

        this.setState({ swapping: true, swap_bentrokan_error: null });

        axios.post(`${conf.uri_backend}api/v1/jadwal-v2/jadwal/swap-slot`, payload, this.getApiHeaders())
            .then((res) => {
                this.setState({ swapping: false });
                if (res.data.status) {
                    this.showToast(res.data.message || "Slot jadwal berhasil ditukar!", "success");
                    this.closeSwapModal();
                    this.cancelVisualSwap();
                    this.loadJadwal();
                    this.loadBentrokan();
                } else if (res.data.is_bentrok) {
                    this.setState({
                        swap_bentrokan_error: {
                            message: res.data.message || "Terdeteksi bentrokan jika slot ditukar.",
                            bentrokan: res.data.bentrokan || []
                        }
                    });
                } else {
                    this.showToast(res.data.message || "Gagal menukar slot jadwal.", "error");
                }
            })
            .catch((err) => {
                this.setState({ swapping: false });
                const data = err.response?.data;
                if (data?.is_bentrok) {
                    this.setState({
                        swap_bentrokan_error: {
                            message: data.message || "Terdeteksi bentrokan jika slot ditukar.",
                            bentrokan: data.bentrokan || []
                        }
                    });
                } else {
                    this.showToast(data?.message || err.message || "Terjadi kesalahan saat menukar slot.", "error");
                }
            });
    }

    // ========================================================
    //  GET SLOTS FOR A SPECIFIC DAY (STABLE & ANCHORED)
    // ========================================================
    getDaySlots(hariNumber, namaHari) {
        const { jadwal, selected_rombel, rombel_list, jadwal_by_hari } = this.state;
        const selectedRombelInfo = (rombel_list || []).find(r => r.rombel_nama === selected_rombel);
        const selectedTingkat = selectedRombelInfo ? selectedRombelInfo.kelas : null;
        const waktuByHari = this.getWaktuByHari(selectedTingkat);

        // Map schedules for this day: { [jam_ke]: item }
        const dayJadwalMap = {};
        (jadwal || []).forEach(j => {
            if (Number(j.hari) === Number(hariNumber) && j.mapel_nama) {
                dayJadwalMap[Number(j.jam_ke)] = j;
            }
        });

        // Waktu slots configured for this day
        const dayWaktuSlots = waktuByHari[hariNumber] || [];

        if (dayWaktuSlots.length > 0) {
            return dayWaktuSlots.map((w, idx) => {
                const jamKe = Number(w.jam_ke);
                const tipe = w.tipe || (w.is_istirahat ? 'istirahat' : 'pelajaran');
                const isBreak = tipe === 'istirahat' || tipe === 'upacara' || tipe === 'kegiatan';
                const fmtTime = (t) => t ? t.substring(0, 5) : '';
                const waktuLabel = `${fmtTime(w.waktu_mulai)} - ${fmtTime(w.waktu_selesai)}`;
                const jadwalEntry = !isBreak ? dayJadwalMap[jamKe] : null;

                return {
                    hari: Number(hariNumber),
                    nama_hari: namaHari,
                    jam_ke: jamKe,
                    urutan: w.urutan !== undefined ? w.urutan : idx,
                    waktu_mulai: w.waktu_mulai,
                    waktu_selesai: w.waktu_selesai,
                    waktuLabel: waktuLabel,
                    is_break: isBreak,
                    tipe: tipe,
                    keterangan_waktu: w.keterangan,
                    jadwal: jadwalEntry || null,
                    is_filled: Boolean(jadwalEntry && jadwalEntry.mapel_nama),
                };
            });
        }

        // Fallback: use items from raw jadwal_by_hari[namaHari]
        const rawDayItems = (jadwal_by_hari && jadwal_by_hari[namaHari]) || [];
        if (rawDayItems.length > 0) {
            return rawDayItems.map((item, idx) => {
                const jamKe = Number(item.jam_ke);
                const isBreak = item.is_istirahat || item.tipe === 'istirahat' || item.tipe === 'upacara' || item.tipe === 'kegiatan';
                const fmtTime = (t) => t ? t.substring(0, 5) : '';
                const waktuLabel = `${fmtTime(item.jam_mulai)} - ${fmtTime(item.jam_selesai)}`;
                const isFilled = Boolean(item.id && item.mapel_nama);

                return {
                    hari: Number(hariNumber),
                    nama_hari: namaHari,
                    jam_ke: jamKe,
                    urutan: idx,
                    waktu_mulai: item.jam_mulai,
                    waktu_selesai: item.jam_selesai,
                    waktuLabel: waktuLabel,
                    is_break: isBreak,
                    tipe: item.tipe || (isBreak ? 'istirahat' : 'pelajaran'),
                    keterangan_waktu: item.waktu_keterangan,
                    jadwal: isFilled ? item : null,
                    is_filled: isFilled,
                };
            });
        }

        return [];
    }

    // ========================================================
    //  RENDER SCHEDULE PER HARI (REKOMENDASI - MANDIRI PER HARI)
    // ========================================================
    renderPerHari() {
        const { selected_rombel, active_day_tab, is_visual_swap, visual_swap_source } = this.state;
        const hariList = this.getActiveDays();
        const daysToRender = active_day_tab === 'all'
            ? hariList
            : [Number(active_day_tab)];

        return (
            <div className="pc-per-hari-container">
                <div className={`pc-per-hari-grid ${active_day_tab === 'all' ? 'pc-grid-2-col' : 'pc-grid-1-col'}`}>
                    {daysToRender.map((h) => {
                        const namaHari = this.renderHariLabel(h);
                        const daySlots = this.getDaySlots(h, namaHari);
                        const filledCount = daySlots.filter(s => s.is_filled).length;
                        const lessonSlots = daySlots.filter(s => !s.is_break).length;
                        const jamAwal = daySlots[0]?.waktu_mulai ? daySlots[0].waktu_mulai.substring(0, 5) : "07:00";
                        const jamAkhir = daySlots[daySlots.length - 1]?.waktu_selesai ? daySlots[daySlots.length - 1].waktu_selesai.substring(0, 5) : "15:00";

                        return (
                            <div className="pc-day-card pc-fade-in" key={h}>
                                <div className="pc-day-card-header">
                                    <div className="pc-day-header-left">
                                        <div className="pc-day-icon-circle">
                                            <i className="bx bx-calendar"></i>
                                        </div>
                                        <div>
                                            <h3 className="pc-day-title">Jadwal Hari {namaHari}</h3>
                                            <span className="pc-day-meta-sub">
                                                <i className="bx bx-time-five"></i> {jamAwal} - {jamAkhir}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="pc-day-header-right">
                                        <span className={`pc-badge ${filledCount === lessonSlots && lessonSlots > 0 ? 'pc-badge-success' : 'pc-badge-primary'}`}>
                                            {filledCount} / {lessonSlots} Jam Terisi
                                        </span>
                                    </div>
                                </div>

                                <div className="pc-day-table-wrap">
                                    <table className="pc-day-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 68, textAlign: 'center' }}>Jam Ke</th>
                                                <th style={{ width: 110 }}>Waktu</th>
                                                <th>Mata Pelajaran</th>
                                                <th>Guru Pengajar</th>
                                                <th style={{ width: 90 }}>Ruang</th>
                                                <th style={{ width: 170, textAlign: 'center' }}>Aksi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {daySlots.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" style={{ textAlign: 'center', padding: '24px', color: '#94a3b8' }}>
                                                        <i className="bx bx-calendar-x" style={{ fontSize: 24, display: 'block', marginBottom: 6 }}></i>
                                                        Tidak ada slot waktu pelajaran di hari {namaHari}
                                                    </td>
                                                </tr>
                                            ) : (
                                                daySlots.map((slot, sIdx) => {
                                                    const { jam_ke, waktuLabel, is_break, tipe, keterangan_waktu, jadwal, is_filled } = slot;

                                                    // Visual swap checking
                                                    const isSwapSource = is_visual_swap && visual_swap_source &&
                                                        visual_swap_source.rombel_nama === selected_rombel &&
                                                        Number(visual_swap_source.hari) === Number(h) &&
                                                        Number(visual_swap_source.jam_ke) === Number(jam_ke);

                                                    if (is_break) {
                                                        const breakLabel = keterangan_waktu || (tipe === 'istirahat' ? 'Istirahat' : tipe === 'upacara' ? 'Upacara Bendera' : tipe);
                                                        const breakIcon = tipe === 'upacara' ? 'bx-flag' : tipe === 'kegiatan' ? 'bx-run' : 'bx-coffee';
                                                        return (
                                                            <tr key={`break_${sIdx}`} className="pc-day-row-break">
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <i className={`bx ${breakIcon}`} style={{ fontSize: 16, color: '#f59e0b' }}></i>
                                                                </td>
                                                                <td style={{ color: '#78716c', fontSize: 12 }}>{waktuLabel}</td>
                                                                <td colSpan="4">
                                                                    <span className="pc-break-inline-badge">
                                                                        <i className={`bx ${breakIcon}`}></i> {breakLabel}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    if (is_filled && jadwal) {
                                                        return (
                                                            <tr
                                                                key={`filled_${jam_ke}_${sIdx}`}
                                                                className={`pc-day-row-filled ${isSwapSource ? 'pc-row-swap-source' : ''} ${is_visual_swap && !isSwapSource ? 'pc-row-swap-target' : ''}`}
                                                                onClick={is_visual_swap ? () => this.onCellClick(jadwal, h, jam_ke, waktuLabel) : undefined}
                                                            >
                                                                <td style={{ textAlign: 'center' }}>
                                                                    <span className="pc-jam-number-badge">
                                                                        {jam_ke}
                                                                    </span>
                                                                </td>
                                                                <td style={{ fontSize: 12, fontWeight: 600, color: '#475569' }}>
                                                                    {waktuLabel}
                                                                </td>
                                                                <td>
                                                                    <div className="pc-mapel-cell-content">
                                                                        <strong className="pc-mapel-title">{jadwal.mapel_nama}</strong>
                                                                        {jadwal.mapel_kode && (
                                                                            <span className="pc-kode-badge">{jadwal.mapel_kode}</span>
                                                                        )}
                                                                        {jadwal.keterangan && (
                                                                            <small style={{ color: '#64748b', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: 3, marginTop: 2 }}>
                                                                                <i className="bx bx-info-circle" style={{ fontSize: 11, color: '#8b5cf6' }}></i>
                                                                                {jadwal.keterangan}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="pc-guru-cell-content">
                                                                        <span className="pc-guru-name">
                                                                            <i className="bx bx-user" style={{ color: '#4f46e5', marginRight: 4 }}></i>
                                                                            {jadwal.guru_nama}
                                                                        </span>
                                                                        {jadwal.guru_nip && (
                                                                            <small className="pc-guru-nip">NIP. {jadwal.guru_nip}</small>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    {jadwal.ruang ? (
                                                                        <span className="pc-ruang-tag">
                                                                            <i className="bx bx-building"></i> {jadwal.ruang}
                                                                        </span>
                                                                    ) : (
                                                                        <span style={{ color: '#cbd5e1' }}>-</span>
                                                                    )}
                                                                </td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    {isSwapSource ? (
                                                                        <span className="pc-badge pc-badge-warning" style={{ fontSize: 11 }}>
                                                                            <i className="bx bx-check"></i> Sumber Tukar
                                                                        </span>
                                                                    ) : is_visual_swap ? (
                                                                        <button
                                                                            className="pc-btn pc-btn-xs pc-btn-success"
                                                                            onClick={() => this.onCellClick(jadwal, h, jam_ke, waktuLabel)}
                                                                        >
                                                                            <i className="bx bx-transfer-alt"></i> Tukar ke Sini
                                                                        </button>
                                                                    ) : (
                                                                        <div className="pc-row-actions">
                                                                            <button
                                                                                className="pc-btn-action-sm pc-btn-action-edit"
                                                                                title="Edit slot ini"
                                                                                onClick={() => this.openEditModal(jadwal, h, jam_ke, waktuLabel)}
                                                                            >
                                                                                <i className="bx bx-pencil"></i> Edit
                                                                            </button>
                                                                            <button
                                                                                className="pc-btn-action-sm pc-btn-action-swap"
                                                                                title="Tukar posisi slot ini"
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        show_swap_modal: true,
                                                                                        swap_slot_a: {
                                                                                            id: jadwal.id,
                                                                                            versi_id: jadwal.versi_id,
                                                                                            rombel_nama: jadwal.rombel_nama || selected_rombel,
                                                                                            hari: h,
                                                                                            jam_ke: jam_ke,
                                                                                            mapel_nama: jadwal.mapel_nama,
                                                                                            guru_nama: jadwal.guru_nama,
                                                                                            waktuLabel: waktuLabel
                                                                                        },
                                                                                        swap_target_rombel: jadwal.rombel_nama || selected_rombel,
                                                                                        swap_slot_b: null,
                                                                                        swap_bentrokan_error: null
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <i className="bx bx-transfer-alt"></i> Tukar
                                                                            </button>
                                                                            <button
                                                                                className="pc-btn-action-sm pc-btn-action-del"
                                                                                title="Kosongkan slot ini"
                                                                                onClick={() => this.promptDeleteSlot(jadwal)}
                                                                            >
                                                                                <i className="bx bx-trash"></i>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        );
                                                    }

                                                    // Empty Slot
                                                    return (
                                                        <tr
                                                            key={`empty_${jam_ke}_${sIdx}`}
                                                            className={`pc-day-row-empty ${isSwapSource ? 'pc-row-swap-source' : ''} ${is_visual_swap && !isSwapSource ? 'pc-row-swap-target' : ''}`}
                                                            onClick={is_visual_swap ? () => this.onCellClick(null, h, jam_ke, waktuLabel) : undefined}
                                                        >
                                                            <td style={{ textAlign: 'center' }}>
                                                                <span className="pc-jam-number-badge pc-jam-empty">
                                                                    {jam_ke}
                                                                </span>
                                                            </td>
                                                            <td style={{ fontSize: 12, color: '#94a3b8' }}>
                                                                {waktuLabel}
                                                            </td>
                                                            <td style={{ color: '#94a3b8', fontStyle: 'italic', fontSize: 12.5 }}>
                                                                <i className="bx bx-circle" style={{ fontSize: 8, marginRight: 6 }}></i>
                                                                Slot Kosong
                                                            </td>
                                                            <td style={{ color: '#cbd5e1' }}>-</td>
                                                            <td style={{ color: '#cbd5e1' }}>-</td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                {isSwapSource ? (
                                                                    <span className="pc-badge pc-badge-warning" style={{ fontSize: 11 }}>
                                                                        <i className="bx bx-check"></i> Sumber Tukar
                                                                    </span>
                                                                ) : is_visual_swap ? (
                                                                    <button
                                                                        className="pc-btn pc-btn-xs pc-btn-success"
                                                                        onClick={() => this.onCellClick(null, h, jam_ke, waktuLabel)}
                                                                    >
                                                                        <i className="bx bx-transfer-alt"></i> Pindah ke Sini
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="pc-btn pc-btn-sm pc-btn-primary pc-btn-isi-slot"
                                                                        onClick={() => this.openEditModal(null, h, jam_ke, waktuLabel)}
                                                                    >
                                                                        <i className="bx bx-plus"></i> Isi Slot Jam {jam_ke}
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    // ========================================================
    //  RENDER MATRIX TABLE (PREMIUM STYLED MATRIX VIEW)
    // ========================================================
    renderMatrix() {
        const { jadwal, selected_rombel, rombel_list, is_visual_swap, visual_swap_source } = this.state;
        const selectedRombelInfo = (rombel_list || []).find(r => r.rombel_nama === selected_rombel);
        const selectedTingkat = selectedRombelInfo ? selectedRombelInfo.kelas : null;
        const waktuByHari = this.getWaktuByHari(selectedTingkat);

        const jadwalMatrix = {};
        jadwal.forEach((j) => {
            if (j.mapel_nama) {
                if (!jadwalMatrix[j.hari]) jadwalMatrix[j.hari] = {};
                if (!jadwalMatrix[j.hari][j.jam_ke]) jadwalMatrix[j.hari][j.jam_ke] = [];
                jadwalMatrix[j.hari][j.jam_ke].push(j);
            }
        });

        const hariSet = new Set();
        jadwal.forEach((j) => { if (j.mapel_nama) hariSet.add(Number(j.hari)); });
        Object.keys(waktuByHari).forEach(h => hariSet.add(Number(h)));
        const hariList = Array.from(hariSet).sort((a, b) => a - b);
        const maxEntries = Math.max(...hariList.map(h => (waktuByHari[h] || []).length), 0);

        if (maxEntries === 0) {
            return (
                <div className="pc-empty-state">
                    <i className="bx bx-calendar-x"></i>
                    <p>Waktu pelajaran belum diatur untuk kurikulum ini.</p>
                </div>
            );
        }

        return (
            <div className="pc-matrix-wrapper pc-fade-in">
                <div className="pc-matrix-toolbar">
                    <div className="pc-matrix-toolbar-left">
                        <span className="pc-matrix-badge-rombel">
                            <i className="bx bx-chalkboard"></i> {selected_rombel}
                        </span>
                        <span className="pc-matrix-toolbar-info">
                            Matriks Jadwal Mingguan
                        </span>
                    </div>
                    <div className="pc-matrix-legend">
                        <span className="pc-matrix-legend-item">
                            <span className="pc-matrix-legend-dot pc-legend-filled"></span> Terisi
                        </span>
                        <span className="pc-matrix-legend-item">
                            <span className="pc-matrix-legend-dot pc-legend-empty"></span> Slot Kosong
                        </span>
                        <span className="pc-matrix-legend-item">
                            <span className="pc-matrix-legend-dot pc-legend-break"></span> Istirahat / Upacara
                        </span>
                        <span className="pc-matrix-legend-hint">
                            <i className="bx bx-mouse"></i> Klik slot untuk edit / tukar
                        </span>
                    </div>
                </div>

                <div className="pc-matrix-table-scroll">
                    <table className="pc-matrix-table">
                        <thead>
                            <tr>
                                <th className="pc-matrix-th-jam">
                                    <div className="pc-matrix-th-jam-inner">
                                        <i className="bx bx-time-five"></i>
                                        <span>Jam</span>
                                    </div>
                                </th>
                                {hariList.map((h) => {
                                    const daySlots = this.getDaySlots(h, this.renderHariLabel(h));
                                    const filledCount = daySlots.filter(s => s.is_filled).length;
                                    const lessonCount = daySlots.filter(s => !s.is_break).length;
                                    return (
                                        <th key={h} className="pc-matrix-th-day">
                                            <div className="pc-matrix-th-day-inner">
                                                <div className="pc-matrix-th-day-name">
                                                    <i className="bx bx-calendar-event"></i>
                                                    <span>{this.renderHariLabel(h)}</span>
                                                </div>
                                                <span className="pc-matrix-th-day-count">
                                                    {filledCount}/{lessonCount} Terisi
                                                </span>
                                            </div>
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({ length: maxEntries }, (_, rowIdx) => {
                                let refTime = "";
                                for (const h of hariList) {
                                    const entry = (waktuByHari[h] || [])[rowIdx];
                                    if (entry && entry.waktu_mulai && entry.waktu_selesai) {
                                        const fmtTime = (t) => t ? t.substring(0, 5) : '';
                                        refTime = `${fmtTime(entry.waktu_mulai)} - ${fmtTime(entry.waktu_selesai)}`;
                                        break;
                                    }
                                }

                                return (
                                    <tr key={rowIdx}>
                                        <td className="pc-matrix-jam-cell">
                                            <div className="pc-matrix-jam-box">
                                                <span className="pc-matrix-jam-num">{rowIdx + 1}</span>
                                                {refTime && <span className="pc-matrix-jam-time">{refTime}</span>}
                                            </div>
                                        </td>
                                        {hariList.map((hari) => {
                                            const entry = (waktuByHari[hari] || [])[rowIdx];
                                            if (!entry) {
                                                return (
                                                    <td key={hari} className="pc-matrix-cell-no-slot">
                                                        <div className="pc-matrix-no-slot-inner">
                                                            <span>—</span>
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            const tipe = entry.tipe || (entry.is_istirahat ? 'istirahat' : 'pelajaran');
                                            const isBreak = tipe === 'istirahat' || tipe === 'upacara' || tipe === 'kegiatan';
                                            const fmtTime = (t) => t ? t.substring(0, 5) : '';
                                            const waktuLabel = `${fmtTime(entry.waktu_mulai)} - ${fmtTime(entry.waktu_selesai)}`;

                                            if (isBreak) {
                                                const breakIcon = tipe === 'upacara' ? 'bx-flag' : tipe === 'kegiatan' ? 'bx-run' : 'bx-coffee';
                                                const breakText = entry.keterangan || (tipe === 'istirahat' ? 'Istirahat' : tipe === 'upacara' ? 'Upacara' : tipe);
                                                return (
                                                    <td key={hari} className="pc-matrix-cell-break">
                                                        <div className="pc-matrix-break-inner">
                                                            <div className="pc-matrix-break-icon">
                                                                <i className={`bx ${breakIcon}`}></i>
                                                            </div>
                                                            <span className="pc-matrix-break-label">{breakText}</span>
                                                            <span className="pc-matrix-break-time">{waktuLabel}</span>
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            const jamKe = Number(entry.jam_ke);
                                            const cells = (jadwalMatrix[hari] && jadwalMatrix[hari][jamKe]) || [];
                                            const firstCell = cells.find(c => c && c.id && c.mapel_nama) || null;

                                            const isSwapSource = is_visual_swap && visual_swap_source &&
                                                visual_swap_source.rombel_nama === selected_rombel &&
                                                Number(visual_swap_source.hari) === Number(hari) &&
                                                Number(visual_swap_source.jam_ke) === Number(jamKe);

                                            if (firstCell) {
                                                return (
                                                    <td
                                                        key={hari}
                                                        className={`pc-matrix-cell-interactive pc-matrix-cell-filled ${isSwapSource ? "pc-matrix-swap-source" : ""} ${is_visual_swap && !isSwapSource ? "pc-matrix-swap-target" : ""}`}
                                                        onClick={() => this.onCellClick(firstCell, hari, jamKe, waktuLabel)}
                                                        title={is_visual_swap ? (isSwapSource ? "Slot sumber tukar" : "Klik untuk menukar dengan slot ini") : `Klik untuk edit slot Jam ${jamKe}`}
                                                    >
                                                        <div className="pc-matrix-card-content">
                                                            {isSwapSource && (
                                                                <div className="pc-matrix-swap-source-badge">
                                                                    <i className="bx bx-check"></i> Sumber Tukar
                                                                </div>
                                                            )}

                                                            <div className="pc-matrix-cell-header">
                                                                <div className="pc-matrix-mapel-wrap">
                                                                    <strong className="pc-matrix-mapel-title" title={firstCell.mapel_nama}>
                                                                        {firstCell.mapel_nama}
                                                                    </strong>
                                                                    {firstCell.mapel_kode && (
                                                                        <span className="pc-matrix-mapel-kode">{firstCell.mapel_kode}</span>
                                                                    )}
                                                                </div>

                                                                {!is_visual_swap && (
                                                                    <div className="pc-matrix-actions-hover" onClick={e => e.stopPropagation()}>
                                                                        <button
                                                                            className="pc-cell-btn-mini pc-btn-mini-edit"
                                                                            title="Edit slot"
                                                                            onClick={() => this.openEditModal(firstCell, hari, jamKe, waktuLabel)}
                                                                        >
                                                                            <i className="bx bx-pencil"></i>
                                                                        </button>
                                                                        <button
                                                                            className="pc-cell-btn-mini pc-btn-mini-swap"
                                                                            title="Tukar posisi slot ini"
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    show_swap_modal: true,
                                                                                    swap_slot_a: {
                                                                                        id: firstCell.id,
                                                                                        versi_id: firstCell.versi_id,
                                                                                        rombel_nama: firstCell.rombel_nama || selected_rombel,
                                                                                        hari: hari,
                                                                                        jam_ke: jamKe,
                                                                                        mapel_nama: firstCell.mapel_nama,
                                                                                        guru_nama: firstCell.guru_nama,
                                                                                        waktuLabel: waktuLabel
                                                                                    },
                                                                                    swap_target_rombel: firstCell.rombel_nama || selected_rombel,
                                                                                    swap_slot_b: null,
                                                                                    swap_bentrokan_error: null
                                                                                });
                                                                            }}
                                                                        >
                                                                            <i className="bx bx-transfer-alt"></i>
                                                                        </button>
                                                                        <button
                                                                            className="pc-cell-btn-mini pc-btn-mini-del"
                                                                            title="Kosongkan slot"
                                                                            onClick={() => this.promptDeleteSlot(firstCell)}
                                                                        >
                                                                            <i className="bx bx-trash"></i>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="pc-matrix-guru-row">
                                                                <i className="bx bx-user" style={{ color: '#4f46e5', fontSize: 13 }}></i>
                                                                <span className="pc-matrix-guru-name" title={firstCell.guru_nama}>
                                                                    {firstCell.guru_nama}
                                                                </span>
                                                            </div>

                                                            <div className="pc-matrix-meta-row">
                                                                {firstCell.ruang ? (
                                                                    <span className="pc-matrix-tag-ruang">
                                                                        <i className="bx bx-building"></i> {firstCell.ruang}
                                                                    </span>
                                                                ) : <span />}
                                                                <span className="pc-matrix-tag-time">
                                                                    <i className="bx bx-time-five"></i> {waktuLabel}
                                                                </span>
                                                            </div>

                                                            {firstCell.keterangan && (
                                                                <div style={{ fontSize: 10, color: '#64748b', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }} title={`Keterangan: ${firstCell.keterangan}`}>
                                                                    <i className="bx bx-info-circle" style={{ fontSize: 11, color: '#8b5cf6', flexShrink: 0 }}></i>
                                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{firstCell.keterangan}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            // Empty slot
                                            return (
                                                <td
                                                    key={hari}
                                                    className={`pc-matrix-cell-interactive pc-matrix-cell-empty ${isSwapSource ? "pc-matrix-swap-source" : ""} ${is_visual_swap && !isSwapSource ? "pc-matrix-swap-target" : ""}`}
                                                    onClick={() => this.onCellClick(null, hari, jamKe, waktuLabel)}
                                                    title={is_visual_swap ? "Klik untuk memindahkan slot ke sini" : `Klik untuk isi slot Jam ${jamKe}`}
                                                >
                                                    <div className="pc-matrix-empty-inner">
                                                        {is_visual_swap ? (
                                                            <div className="pc-matrix-empty-swap-prompt">
                                                                <i className="bx bx-transfer-alt"></i>
                                                                <span>Pindah ke Sini</span>
                                                            </div>
                                                        ) : (
                                                            <div className="pc-matrix-empty-add-btn">
                                                                <div className="pc-matrix-plus-icon">
                                                                    <i className="bx bx-plus"></i>
                                                                </div>
                                                                <span className="pc-matrix-empty-text">Isi Slot</span>
                                                            </div>
                                                        )}
                                                        <span className="pc-matrix-empty-meta">Jam {jamKe} • {waktuLabel}</span>
                                                    </div>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const {
            rombel_list, versi_list, selected_rombel, selected_versi, loading,
            tahun_ajaran, semester, kurikulum, penugasan_list, guru_list, waktu_list,
            bentrokan_list, show_edit_modal, edit_slot, is_move_slot, saving, bentrokan_error,
            show_swap_modal, swap_slot_a, swap_slot_b, swap_target_rombel, swapping, swap_bentrokan_error,
            is_visual_swap, visual_swap_source, show_delete_confirm, delete_target_slot, deleting,
            toast, active_day_tab, view_mode
        } = this.state;

        const hasData = rombel_list.length > 0;
        const hasVersi = versi_list.length > 0;

        // Filter penugasan for selected rombel
        const rombelPenugasan = penugasan_list.filter(p => p.rombel_nama === selected_rombel);

        // Calculate available time slots for move/swap
        const selectedRombelInfo = (rombel_list || []).find(r => r.rombel_nama === selected_rombel);
        const selectedTingkat = selectedRombelInfo ? selectedRombelInfo.kelas : null;
        const waktuByHari = this.getWaktuByHari(selectedTingkat);
        const availableJamNumbers = [...new Set(waktu_list.filter(w => !w.is_istirahat && w.jam_ke > 0).map(w => Number(w.jam_ke)))].sort((a, b) => a - b);
        const availableHariNumbers = this.getActiveDays();

        return (
            <div className="pc-container pc-editor-container">
                {/* Toast Notification */}
                {toast && (
                    <div className={`pc-toast-floating pc-toast-${toast.type}`}>
                        <i className={`bx ${toast.type === 'success' ? 'bx-check-circle' : toast.type === 'warning' ? 'bx-error' : 'bx-x-circle'}`}></i>
                        <span>{toast.message}</span>
                        <button className="pc-toast-close" onClick={() => this.setState({ toast: null })}>×</button>
                    </div>
                )}

                {/* Floating Visual Swap Bottom Bar */}
                {is_visual_swap && (
                    <div className="pc-swap-floating-bar pc-fade-in">
                        <div className="pc-swap-bar-info">
                            <i className="bx bx-transfer-alt bx-flashing pc-swap-bar-icon"></i>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                    <strong style={{ color: '#ffffff', fontSize: 13 }}>Mode Tukar Slot:</strong>
                                    {visual_swap_source && (
                                        <span className="pc-swap-rombel-pill" style={{ background: '#312e81', color: '#a5b4fc', border: '1px solid #4338ca' }}>
                                            <i className="bx bx-group"></i> Sumber: {visual_swap_source.rombel_nama}
                                        </span>
                                    )}
                                    {visual_swap_source && visual_swap_source.rombel_nama !== selected_rombel && (
                                        <span className="pc-swap-rombel-pill" style={{ background: '#064e3b', color: '#6ee7b7', border: '1px solid #059669' }}>
                                            <i className="bx bx-shuffle"></i> Lintas Rombel ➔ {selected_rombel}
                                        </span>
                                    )}
                                </div>
                                <div style={{ color: '#cbd5e1', fontSize: 12, marginTop: 2 }}>
                                    {visual_swap_source ? (
                                        <span>Sumber: <strong style={{ color: '#fbbf24' }}>[{visual_swap_source.rombel_nama}] {this.renderHariLabel(visual_swap_source.hari)} Jam {visual_swap_source.jam_ke}</strong> ({visual_swap_source.mapel_nama || 'Slot Kosong'}). Klik slot tujuan di tabel (bisa lintas kelas)!</span>
                                    ) : (
                                        <span>Klik slot pertama di tabel sebagai sumber penukaran.</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {visual_swap_source && rombel_list.length > 1 && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.12)', padding: '5px 12px', borderRadius: 20 }}>
                                <span style={{ fontSize: 11.5, color: '#93c5fd', whiteSpace: 'nowrap' }}>
                                    <i className="bx bx-shuffle"></i> Ganti Kelas Tujuan:
                                </span>
                                <select
                                    value={selected_rombel}
                                    onChange={(e) => this.setState({ selected_rombel: e.target.value }, () => this.loadJadwal())}
                                    style={{
                                        background: '#0f172a',
                                        color: '#ffffff',
                                        border: '1px solid #64748b',
                                        borderRadius: 6,
                                        padding: '4px 8px',
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: 'pointer'
                                    }}
                                >
                                    {rombel_list.map((r) => (
                                        <option key={r.rombel_nama} value={r.rombel_nama}>
                                            {r.rombel_nama} {r.rombel_nama === visual_swap_source.rombel_nama ? " (Sumber)" : " (Lintas)"}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        <button className="pc-btn pc-btn-sm pc-btn-danger" onClick={() => this.cancelVisualSwap()}>
                            <i className="bx bx-x"></i> Batal Tukar
                        </button>
                    </div>
                )}

                {/* Page Header */}
                <div className="pc-header">
                    <div className="pc-header-content">
                        <div className="pc-header-text">
                            <h1 className="pc-header-title">
                                <i className="bx bx-edit-alt"></i> Edit Jadwal Pelajaran
                            </h1>
                            <p className="pc-header-subtitle">
                                Ubah slot terisi, isi slot kosong, pindahkan jam/hari, dan tukar posisi slot secara aman dengan deteksi bentrokan.
                            </p>
                        </div>
                        <div className="pc-header-actions">
                            <Link to="/penjadwalan-cerdas/jadwal-kelas" className="pc-btn pc-btn-outline">
                                <i className="bx bx-show"></i> Lihat Jadwal
                            </Link>
                            <Link to="/penjadwalan-cerdas" className="pc-btn pc-btn-outline">
                                <i className="bx bx-arrow-back"></i> Dashboard
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Step-by-step Filter Guide */}
                <div className="pc-filters-guide pc-filters-editor">
                    {/* Step 1: Tahun Ajaran */}
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">1</div>
                        <div className="pc-filter-item">
                            <label>Tahun Ajaran</label>
                            <select className="pc-input" value={tahun_ajaran}
                                onChange={(e) => this.onFilterChange({ tahun_ajaran: e.target.value })}>
                                {this.getTahunAjaranOptions().map((ta) => <option key={ta} value={ta}>{ta}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* Step 2: Semester */}
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">2</div>
                        <div className="pc-filter-item">
                            <label>Semester</label>
                            <select className="pc-input" value={semester}
                                onChange={(e) => this.onFilterChange({ semester: e.target.value })}>
                                <option value="1">Ganjil</option>
                                <option value="2">Genap</option>
                            </select>
                        </div>
                    </div>

                    {/* Step 3: Kurikulum */}
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">3</div>
                        <div className="pc-filter-item">
                            <label>Kurikulum</label>
                            <select className="pc-input" value={kurikulum}
                                onChange={(e) => this.onFilterChange({ kurikulum: e.target.value })}>
                                <option value="merdeka">Merdeka</option>
                                <option value="k13">K13</option>
                            </select>
                        </div>
                    </div>

                    {/* Step 4: Versi */}
                    <div className="pc-filter-step">
                        <div className="pc-step-badge">4</div>
                        <div className="pc-filter-item">
                            <label>Versi Jadwal {!hasVersi && !loading && <span className="pc-filter-hint">(belum ada)</span>}</label>
                            <select className="pc-input" value={selected_versi}
                                disabled={!hasVersi}
                                onChange={(e) => this.setState({ selected_versi: e.target.value }, () => this.loadJadwal())}>
                                <option value="">Versi Aktif</option>
                                {versi_list.map((v) => <option key={v.id} value={v.id}>{v.nama_versi}{v.is_aktif ? " ✓ (Aktif)" : v.is_draft ? " (Draft)" : ""}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* Step 5: Rombel */}
                    <div className="pc-filter-step">
                        <div className="pc-step-badge pc-step-badge-primary">5</div>
                        <div className="pc-filter-item">
                            <label>Pilih Rombel {hasData && <span className="pc-filter-count">{rombel_list.length} kelas</span>}</label>
                            <select className="pc-input pc-input-highlight" value={selected_rombel}
                                disabled={!hasData}
                                onChange={(e) => this.setState({ selected_rombel: e.target.value }, () => this.loadJadwal())}>
                                <option value="">-- Pilih Rombel --</option>
                                {rombel_list.map((r) => <option key={r.rombel_nama} value={r.rombel_nama}>{r.rombel_nama}</option>)}
                            </select>
                        </div>
                    </div>

                    {/* Quick Tools */}
                    <div className="pc-export-btns" style={{ display: 'flex', gap: 8 }}>
                        <button
                            onClick={() => this.toggleVisualSwap()}
                            className={`pc-btn ${is_visual_swap ? 'pc-btn-warning' : 'pc-btn-secondary'}`}
                            title="Tukar posisi 2 slot di tabel secara visual"
                            disabled={!selected_rombel}
                        >
                            <i className="bx bx-transfer-alt"></i> {is_visual_swap ? "Batal Tukar" : "Tukar Slot (Swap)"}
                        </button>
                    </div>
                </div>

                {/* Editor Instructions Banner */}
                {selected_rombel && (
                    <div className="pc-editor-hint-bar">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <i className="bx bx-info-circle" style={{ color: '#4f46e5', fontSize: 20 }}></i>
                            <div style={{ fontSize: 13, color: '#334155' }}>
                                <strong>Panduan Edit:</strong> Klik pada slot mana saja untuk <strong>mengedit mapel/guru</strong>, <strong>mengisi slot kosong</strong>, <strong>memindahkan slot</strong>, atau gunakan tombol <strong>Tukar Slot (Swap)</strong> untuk bertukar posisi slot secara instan.
                            </div>
                        </div>
                        {bentrokan_list.length > 0 ? (
                            <span className="pc-badge pc-badge-danger" style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '4px 10px' }}>
                                <i className="bx bx-error-circle"></i> {bentrokan_list.length} Bentrokan di Versi Ini
                            </span>
                        ) : (
                            <span className="pc-badge pc-badge-success" style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '4px 10px' }}>
                                <i className="bx bx-check-circle"></i> Bebas Bentrok
                            </span>
                        )}
                    </div>
                )}

                {/* Main Schedule Content */}
                {loading ? (
                    <div className="pc-loading"><i className="bx bx-loader-alt bx-spin"></i> Memuat jadwal rombel...</div>
                ) : selected_rombel ? (
                    <div className="pc-section">
                        <div className="pc-section-header-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                            <div>
                                <h2 className="pc-section-title">
                                    <i className="bx bx-calendar-edit"></i> Edit Jadwal — {selected_rombel}
                                </h2>
                                <span className="pc-section-meta">{tahun_ajaran} • Semester {semester} • Kurikulum {kurikulum === 'k13' ? 'K13' : 'Merdeka'}</span>
                            </div>
                            <div className="pc-view-mode-toggle" style={{ display: 'flex', gap: 6, background: '#f1f5f9', padding: 4, borderRadius: 10 }}>
                                <button
                                    className={`pc-view-mode-btn ${view_mode === 'matrix' ? 'pc-view-btn-active' : ''}`}
                                    onClick={() => this.setState({ view_mode: 'matrix' })}
                                    style={{
                                        border: 'none',
                                        padding: '6px 14px',
                                        borderRadius: 8,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        background: view_mode === 'matrix' ? '#4f46e5' : 'transparent',
                                        color: view_mode === 'matrix' ? '#ffffff' : '#64748b'
                                    }}
                                    title="Tampilan Matriks Mingguan"
                                >
                                    <i className="bx bx-table"></i> Tampilan Matriks
                                </button>
                                <button
                                    className={`pc-view-mode-btn ${view_mode === 'per_hari' ? 'pc-view-btn-active' : ''}`}
                                    onClick={() => this.setState({ view_mode: 'per_hari' })}
                                    style={{
                                        border: 'none',
                                        padding: '6px 14px',
                                        borderRadius: 8,
                                        fontSize: 12,
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 6,
                                        background: view_mode === 'per_hari' ? '#4f46e5' : 'transparent',
                                        color: view_mode === 'per_hari' ? '#ffffff' : '#64748b'
                                    }}
                                    title="Tampilan Tabel Per Hari"
                                >
                                    <i className="bx bx-calendar"></i> Tampilan Per Hari
                                </button>
                            </div>
                        </div>

                        {/* Day Tabs Bar (shown in Per Hari view) */}
                        {view_mode === 'per_hari' && (
                            <div className="pc-day-tabs-bar" style={{ display: 'flex', gap: 8, margin: '14px 0 20px', flexWrap: 'wrap' }}>
                                <button
                                    className={`pc-kur-btn ${active_day_tab === 'all' ? 'pc-kur-active' : ''}`}
                                    onClick={() => this.setState({ active_day_tab: 'all' })}
                                    style={{ padding: '8px 16px', fontSize: 13, borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 6 }}
                                >
                                    <i className="bx bx-grid-alt"></i> Semua Hari (Grid)
                                </button>
                                {availableHariNumbers.map(h => {
                                    const namaHari = this.renderHariLabel(h);
                                    const slots = this.getDaySlots(h, namaHari);
                                    const filled = slots.filter(s => s.is_filled).length;
                                    return (
                                        <button
                                            key={h}
                                            className={`pc-kur-btn ${active_day_tab === String(h) ? 'pc-kur-active' : ''}`}
                                            onClick={() => this.setState({ active_day_tab: String(h) })}
                                            style={{ padding: '8px 16px', fontSize: 13, borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 6 }}
                                        >
                                            <i className="bx bx-calendar-event"></i> {namaHari}
                                            <span style={{
                                                fontSize: 11,
                                                padding: '2px 6px',
                                                borderRadius: 10,
                                                background: active_day_tab === String(h) ? 'rgba(255,255,255,0.25)' : '#e2e8f0',
                                                color: active_day_tab === String(h) ? '#ffffff' : '#475569'
                                            }}>
                                                {filled} jam
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        )}

                        {view_mode === 'per_hari' ? this.renderPerHari() : this.renderMatrix()}
                    </div>
                ) : hasData ? (
                    <div className="pc-section">
                        <div className="pc-empty-state">
                            <i className="bx bx-select-multiple"></i>
                            <p>Pilih rombel di atas untuk mulai mengedit jadwal</p>
                            <small>{rombel_list.length} rombel tersedia</small>
                        </div>
                    </div>
                ) : (
                    <div className="pc-info-banner pc-info-warning">
                        <i className="bx bx-info-circle"></i>
                        <div>
                            <strong>Belum ada data jadwal</strong>
                            <p>Tidak ditemukan jadwal untuk filter ini. Silakan generate jadwal terlebih dahulu melalui menu Wizard.</p>
                        </div>
                    </div>
                )}

                {/* ========================================================
                    MODAL: EDIT / ISI SLOT
                   ======================================================== */}
                {show_edit_modal && edit_slot && (
                    <div className="pc-modal-overlay" onClick={() => this.closeEditModal()}>
                        <div className="pc-modal-content pc-modal-lg pc-edit-slot-modal pc-modal-structured" onClick={e => e.stopPropagation()}>
                            <div className="pc-modal-header-custom">
                                <div>
                                    <h4>
                                        <i className={`bx ${edit_slot.id ? 'bx-edit-alt' : 'bx-plus-circle'}`}></i>
                                        {edit_slot.id ? "Edit Slot Jadwal" : "Isi Slot Jadwal Baru"}
                                    </h4>
                                    <span className="pc-modal-slot-meta">
                                        <strong>{edit_slot.rombel_nama}</strong> • {this.renderHariLabel(edit_slot.hari)}, Jam ke-{edit_slot.jam_ke} {edit_slot.waktuLabel && `(${edit_slot.waktuLabel})`}
                                    </span>
                                </div>
                                <button className="pc-modal-close-btn" onClick={() => this.closeEditModal()}>×</button>
                            </div>

                            <div className="pc-modal-body">
                                {/* Bentrokan Warning Box */}
                                {bentrokan_error && (
                                    <div className="pc-bentrok-alert pc-fade-in">
                                        <div className="pc-bentrok-alert-title">
                                            <i className="bx bx-error-circle"></i>
                                            <strong>{bentrokan_error.message}</strong>
                                        </div>
                                        <ul className="pc-bentrok-list">
                                            {bentrokan_error.bentrokan.map((b, idx) => (
                                                <li key={idx}>
                                                    <span className={`pc-badge-bentrok ${b.tipe === 'guru_bentrok' ? 'pc-badge-guru' : 'pc-badge-rombel'}`}>
                                                        {b.tipe === 'guru_bentrok' ? 'Guru Bentrok' : 'Rombel Bentrok'}
                                                    </span>
                                                    <span className="pc-bentrok-pesan">{b.pesan}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="pc-bentrok-force-callout">
                                            <p>Apakah Anda ingin tetap memaksakan perubahan ini dan mengabaikan bentrokan jadwal?</p>
                                            <button
                                                className="pc-btn pc-btn-sm pc-btn-danger"
                                                disabled={saving}
                                                onClick={() => this.handleSaveSlot(true)}
                                            >
                                                <i className="bx bx-check-shield"></i> {saving ? "Menyimpan..." : "Ya, Tetap Simpan (Force / Paksa)"}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Penugasan Quick Selector */}
                                {rombelPenugasan.length > 0 && (
                                    <div className="pc-form-group pc-quick-penugasan">
                                        <label>
                                            <i className="bx bx-bolt-circle"></i> Pilih Cepat dari Penugasan Rombel {edit_slot.rombel_nama}:
                                        </label>
                                        <select className="pc-input pc-input-sm" onChange={(e) => this.onSelectPenugasan(e)} defaultValue="">
                                            <option value="">-- Pilih Mata Pelajaran yang Ditugaskan --</option>
                                            {rombelPenugasan.map((p, i) => (
                                                <option key={i} value={`${p.mapel_nama}|||${p.guru_nama}`}>
                                                    {p.mapel_nama} — {p.guru_nama} ({p.jumlah_jam_per_minggu} jam/mgg)
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                <div className="pc-form-grid-2">
                                    {/* Mata Pelajaran */}
                                    <div className="pc-form-group">
                                        <label>Mata Pelajaran <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="pc-input"
                                            placeholder="Contoh: Matematika"
                                            value={edit_slot.mapel_nama}
                                            onChange={(e) => this.setState({ edit_slot: { ...edit_slot, mapel_nama: e.target.value } })}
                                        />
                                    </div>

                                    {/* Kode Mapel */}
                                    <div className="pc-form-group">
                                        <label>Kode Mapel (Opsional)</label>
                                        <input
                                            type="text"
                                            className="pc-input"
                                            placeholder="Contoh: MAT-01"
                                            value={edit_slot.mapel_kode}
                                            onChange={(e) => this.setState({ edit_slot: { ...edit_slot, mapel_kode: e.target.value } })}
                                        />
                                    </div>
                                </div>

                                <div className="pc-form-grid-2">
                                    {/* Guru Pengajar */}
                                    <div className="pc-form-group">
                                        <label>Guru Pengajar <span style={{ color: '#ef4444' }}>*</span></label>
                                        <input
                                            type="text"
                                            className="pc-input"
                                            placeholder="Pilih atau ketik nama guru..."
                                            list="list-guru-options"
                                            value={edit_slot.guru_nama}
                                            onChange={(e) => {
                                                const name = e.target.value;
                                                const matchedGuru = guru_list.find(g => g.nama === name);
                                                this.setState({
                                                    edit_slot: {
                                                        ...edit_slot,
                                                        guru_nama: name,
                                                        guru_nip: matchedGuru?.nip || edit_slot.guru_nip
                                                    }
                                                });
                                            }}
                                        />
                                        <datalist id="list-guru-options">
                                            {guru_list.map((g) => (
                                                <option key={g.id} value={g.nama}>{g.nama} ({g.nip || 'Tanpa NIP'})</option>
                                            ))}
                                        </datalist>
                                    </div>

                                    {/* Ruang */}
                                    <div className="pc-form-group">
                                        <label>Ruangan (Opsional)</label>
                                        <input
                                            type="text"
                                            className="pc-input"
                                            placeholder="Contoh: R. 7A / Lab Komputer"
                                            value={edit_slot.ruang || ""}
                                            onChange={(e) => this.setState({ edit_slot: { ...edit_slot, ruang: e.target.value } })}
                                        />
                                    </div>
                                </div>

                                {/* Keterangan */}
                                <div className="pc-form-group">
                                    <label>Keterangan (Opsional)</label>
                                    <input
                                        type="text"
                                        className="pc-input"
                                        placeholder="Contoh: Teori, Praktik, Pemisahan agama, dll."
                                        value={edit_slot.keterangan || ""}
                                        onChange={(e) => this.setState({ edit_slot: { ...edit_slot, keterangan: e.target.value } })}
                                    />
                                </div>

                                {/* Pindah Waktu (Hari & Jam lain) */}
                                <div className="pc-move-slot-toggle">
                                    <label className="pc-checkbox-label">
                                        <input
                                            type="checkbox"
                                            checked={is_move_slot}
                                            onChange={(e) => this.setState({ is_move_slot: e.target.checked })}
                                        />
                                        <span>Pindahkan slot ini ke Hari & Jam lain</span>
                                    </label>

                                    {is_move_slot && (
                                        <div className="pc-move-slot-inputs pc-fade-in">
                                            <div className="pc-form-group">
                                                <label>Target Hari</label>
                                                <select
                                                    className="pc-input"
                                                    value={edit_slot.target_hari}
                                                    onChange={(e) => {
                                                        const newHari = Number(e.target.value);
                                                        const targetDaySlots = (waktuByHari[newHari] || []).filter(w => !w.is_istirahat && Number(w.jam_ke) > 0);
                                                        const validJams = targetDaySlots.map(w => Number(w.jam_ke));
                                                        const currentJam = Number(edit_slot.target_jam_ke);
                                                        const nextJam = validJams.includes(currentJam) ? currentJam : (validJams[0] || 1);
                                                        this.setState({
                                                            edit_slot: {
                                                                ...edit_slot,
                                                                target_hari: newHari,
                                                                target_jam_ke: nextJam
                                                            }
                                                        });
                                                    }}
                                                >
                                                    {availableHariNumbers.map(h => (
                                                        <option key={h} value={h}>{this.renderHariLabel(h)}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="pc-form-group">
                                                <label>Target Jam Ke</label>
                                                <select
                                                    className="pc-input"
                                                    value={edit_slot.target_jam_ke}
                                                    onChange={(e) => this.setState({ edit_slot: { ...edit_slot, target_jam_ke: Number(e.target.value) } })}
                                                >
                                                    {(() => {
                                                        const targetDaySlots = (waktuByHari[Number(edit_slot.target_hari)] || []).filter(w => !w.is_istirahat && Number(w.jam_ke) > 0);
                                                        const sortedSlots = [...targetDaySlots].sort((a, b) => (Number(a.jam_ke) || 0) - (Number(b.jam_ke) || 0));
                                                        return sortedSlots.map(w => {
                                                            const fmtTime = (t) => t ? t.substring(0, 5) : '';
                                                            const timeStr = (w.waktu_mulai && w.waktu_selesai) ? ` (${fmtTime(w.waktu_mulai)} - ${fmtTime(w.waktu_selesai)})` : '';
                                                            return (
                                                                <option key={w.jam_ke} value={w.jam_ke}>Jam ke-{w.jam_ke}{timeStr}</option>
                                                            );
                                                        });
                                                    })()}
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal Footer Actions */}
                            <div className="pc-modal-footer-custom">
                                <div className="pc-modal-footer-left">
                                    {edit_slot.id && (
                                        <>
                                            <button
                                                className="pc-btn pc-btn-danger-outline"
                                                title="Kosongkan jadwal pada slot ini"
                                                onClick={() => this.promptDeleteSlot(edit_slot)}
                                            >
                                                <i className="bx bx-trash"></i> Kosongkan Slot
                                            </button>
                                            <button
                                                className="pc-btn pc-btn-secondary"
                                                title="Tukar posisi slot ini dengan slot lain"
                                                onClick={() => this.openSwapModalFromEdit()}
                                            >
                                                <i className="bx bx-transfer-alt"></i> Tukar Posisi (Swap)
                                            </button>
                                        </>
                                    )}
                                </div>
                                <div className="pc-modal-footer-right">
                                    <button className="pc-btn pc-btn-ghost" onClick={() => this.closeEditModal()}>
                                        Batal
                                    </button>
                                    <button
                                        className="pc-btn pc-btn-primary"
                                        disabled={saving}
                                        onClick={() => this.handleSaveSlot(false)}
                                    >
                                        <i className="bx bx-save"></i> {saving ? "Menyimpan..." : "Simpan Slot"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ========================================================
                    MODAL: SWAP SLOT (TUKAR POSISI DUA SLOT)
                   ======================================================== */}
                {show_swap_modal && swap_slot_a && (
                    <div className="pc-modal-overlay" onClick={() => this.closeSwapModal()}>
                        <div className="pc-modal-content pc-modal-md pc-swap-modal pc-modal-structured" onClick={e => e.stopPropagation()}>
                            <div className="pc-modal-header-custom">
                                <h4><i className="bx bx-transfer-alt"></i> Tukar Posisi Dua Slot</h4>
                                <button className="pc-modal-close-btn" onClick={() => this.closeSwapModal()}>×</button>
                            </div>

                            <div className="pc-modal-body">
                                <p style={{ fontSize: 13, color: '#64748b', margin: '0 0 16px' }}>
                                    Tukar posisi antara dua slot secara aman dalam satu transaksi database. Mendukung slot terisi maupun slot kosong, baik dalam satu rombel maupun lintas rombel.
                                </p>

                                {/* Cross Rombel Alert */}
                                {(() => {
                                    const currentTargetRombel = swap_target_rombel || swap_slot_b?.rombel_nama || swap_slot_a.rombel_nama || selected_rombel;
                                    const isCrossRombel = swap_slot_a.rombel_nama !== currentTargetRombel;
                                    if (!isCrossRombel) return null;
                                    return (
                                        <div className="pc-swap-cross-banner pc-fade-in">
                                            <i className="bx bx-shuffle"></i>
                                            <div>
                                                <strong>Penukaran Lintas Rombel Aktif:</strong> Slot di rombel <span className="pc-swap-rombel-pill">{swap_slot_a.rombel_nama}</span> akan ditukar dengan slot di rombel <span className="pc-swap-rombel-pill">{currentTargetRombel}</span>. Jadwal kedua kelas divalidasi otomatis untuk mencegah bentrokan.
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* Bentrokan on Swap Warning */}
                                {swap_bentrokan_error && (
                                    <div className="pc-bentrok-alert pc-fade-in" style={{ marginBottom: 16 }}>
                                        <div className="pc-bentrok-alert-title">
                                            <i className="bx bx-error-circle"></i>
                                            <strong>{swap_bentrokan_error.message}</strong>
                                        </div>
                                        <ul className="pc-bentrok-list">
                                            {swap_bentrokan_error.bentrokan.map((b, idx) => (
                                                <li key={idx}>
                                                    <span className={`pc-badge-bentrok ${b.tipe === 'guru_bentrok' ? 'pc-badge-guru' : 'pc-badge-rombel'}`}>
                                                        {b.tipe === 'guru_bentrok' ? 'Guru Bentrok' : 'Rombel Bentrok'}
                                                    </span>
                                                    <span className="pc-bentrok-pesan">{b.pesan}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="pc-bentrok-force-callout">
                                            <p>Terdeteksi bentrokan jika kedua slot ditukar. Lanjutkan penukaran dengan Force?</p>
                                            <button
                                                className="pc-btn pc-btn-sm pc-btn-danger"
                                                disabled={swapping}
                                                onClick={() => this.handleExecuteSwap(true)}
                                            >
                                                <i className="bx bx-check-shield"></i> {swapping ? "Menukar..." : "Tetap Tukar (Force / Paksa)"}
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* Swap Cards Comparison */}
                                <div className="pc-swap-comparison">
                                    {/* Slot A */}
                                    <div className="pc-swap-card pc-swap-card-a">
                                        <div className="pc-swap-badge">Slot Sumber (A)</div>
                                        <div className="pc-swap-card-title">{this.renderHariLabel(swap_slot_a.hari)}, Jam ke-{swap_slot_a.jam_ke}</div>
                                        <div className="pc-swap-card-sub">
                                            <span className="pc-swap-rombel-pill" style={{ background: '#e0e7ff', color: '#4338ca' }}>
                                                <i className="bx bx-group"></i> {swap_slot_a.rombel_nama}
                                            </span>
                                        </div>
                                        <div className="pc-swap-card-content">
                                            <strong>{swap_slot_a.mapel_nama || "(Slot Kosong)"}</strong>
                                            <small>{swap_slot_a.guru_nama || "Tanpa Guru"}</small>
                                        </div>
                                    </div>

                                    <div className="pc-swap-icon-divider">
                                        <i className="bx bx-transfer-alt"></i>
                                    </div>

                                    {/* Slot B */}
                                    <div className="pc-swap-card pc-swap-card-b">
                                        <div className="pc-swap-badge">Slot Tujuan (B)</div>
                                        {swap_slot_b ? (
                                            <>
                                                <div className="pc-swap-card-title">{this.renderHariLabel(swap_slot_b.hari)}, Jam ke-{swap_slot_b.jam_ke}</div>
                                                <div className="pc-swap-card-sub">
                                                    <span className="pc-swap-rombel-pill" style={{ background: '#e0f2fe', color: '#0369a1' }}>
                                                        <i className="bx bx-group"></i> {swap_slot_b.rombel_nama}
                                                    </span>
                                                </div>
                                                <div className="pc-swap-card-content">
                                                    <strong>{swap_slot_b.mapel_nama || "(Slot Kosong)"}</strong>
                                                    <small>{swap_slot_b.guru_nama || "Tanpa Guru"}</small>
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ textAlign: 'center', padding: '16px 0', color: '#94a3b8' }}>
                                                <i className="bx bx-pointer" style={{ fontSize: 24, display: 'block', marginBottom: 4 }}></i>
                                                <span>Pilih slot tujuan dari form di bawah</span>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Dropdowns to pick target Rombel & Slot B */}
                                {(() => {
                                    const currentTargetRombel = swap_target_rombel || swap_slot_b?.rombel_nama || swap_slot_a.rombel_nama || selected_rombel;
                                    const targetSlots = this.getSlotsForRombel(currentTargetRombel);

                                    return (
                                        <div className="pc-form-grid-2" style={{ marginTop: 16 }}>
                                            <div className="pc-form-group">
                                                <label>
                                                    <i className="bx bx-group" style={{ marginRight: 4, color: '#4f46e5' }}></i>
                                                    Kelas / Rombel Tujuan (B):
                                                </label>
                                                <select
                                                    className="pc-input"
                                                    value={currentTargetRombel}
                                                    onChange={(e) => {
                                                        const targetRombel = e.target.value;
                                                        this.setState({
                                                            swap_target_rombel: targetRombel,
                                                            swap_slot_b: null,
                                                            swap_bentrokan_error: null
                                                        });
                                                    }}
                                                >
                                                    {rombel_list.map((r) => (
                                                        <option key={r.rombel_nama} value={r.rombel_nama}>
                                                            {r.rombel_nama} {r.rombel_nama === swap_slot_a.rombel_nama ? " (Sama dengan Slot A)" : " (Lintas Rombel)"}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="pc-form-group">
                                                <label>
                                                    <i className="bx bx-time" style={{ marginRight: 4, color: '#0ea5e9' }}></i>
                                                    Slot di Kelas {currentTargetRombel}:
                                                </label>
                                                <select
                                                    className="pc-input"
                                                    value={swap_slot_b ? `${swap_slot_b.hari}_${swap_slot_b.jam_ke}` : ""}
                                                    onChange={(e) => {
                                                        if (!e.target.value) {
                                                            this.setState({ swap_slot_b: null, swap_bentrokan_error: null });
                                                            return;
                                                        }
                                                        const [h, j] = e.target.value.split("_").map(Number);
                                                        const targetSlot = targetSlots.find(s => Number(s.hari) === h && Number(s.jam_ke) === j);
                                                        if (targetSlot) {
                                                            this.setState({
                                                                swap_slot_b: {
                                                                    id: targetSlot.id,
                                                                    versi_id: targetSlot.versi_id || swap_slot_a.versi_id,
                                                                    rombel_nama: currentTargetRombel,
                                                                    hari: h,
                                                                    jam_ke: j,
                                                                    mapel_nama: targetSlot.mapel_nama || "",
                                                                    guru_nama: targetSlot.guru_nama || "",
                                                                    waktuLabel: targetSlot.waktuLabel || ""
                                                                },
                                                                swap_bentrokan_error: null
                                                            });
                                                        }
                                                    }}
                                                >
                                                    <option value="">-- Pilih Slot Tujuan --</option>
                                                    {targetSlots.map((s) => {
                                                        const isSameSlot = s.rombel_nama === swap_slot_a.rombel_nama &&
                                                            Number(s.hari) === Number(swap_slot_a.hari) &&
                                                            Number(s.jam_ke) === Number(swap_slot_a.jam_ke);
                                                        if (isSameSlot) return null;
                                                        const timeStr = s.waktuLabel ? ` (${s.waktuLabel})` : "";
                                                        return (
                                                            <option key={`${s.hari}_${s.jam_ke}`} value={`${s.hari}_${s.jam_ke}`}>
                                                                {this.renderHariLabel(s.hari)} Jam {s.jam_ke}{timeStr} : {s.is_filled ? `${s.mapel_nama} (${s.guru_nama})` : "(Slot Kosong)"}
                                                            </option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    );
                                })()}
                            </div>

                            <div className="pc-modal-footer-custom pc-modal-actions" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                <div className="pc-modal-footer-left">
                                    <button
                                        className="pc-btn pc-btn-outline"
                                        onClick={() => {
                                            const currentTargetRombel = swap_target_rombel || swap_slot_b?.rombel_nama || swap_slot_a.rombel_nama || selected_rombel;
                                            this.closeSwapModal();
                                            this.setState({
                                                is_visual_swap: true,
                                                visual_swap_source: swap_slot_a,
                                                selected_rombel: currentTargetRombel
                                            }, () => {
                                                if (currentTargetRombel !== selected_rombel) {
                                                    this.loadJadwal();
                                                }
                                            });
                                            this.showToast(`Mode Visual Swap: Pilih slot tujuan di tabel kelas ${currentTargetRombel}!`, "warning");
                                        }}
                                    >
                                        <i className="bx bx-table"></i> Pilih di Tabel {swap_target_rombel && swap_target_rombel !== selected_rombel ? `(${swap_target_rombel})` : ""}
                                    </button>
                                </div>
                                <div className="pc-modal-footer-right">
                                    <button className="pc-btn pc-btn-ghost" onClick={() => this.closeSwapModal()}>
                                        Batal
                                    </button>
                                    <button
                                        className="pc-btn pc-btn-primary"
                                        disabled={!swap_slot_b || swapping}
                                        onClick={() => this.handleExecuteSwap(false)}
                                    >
                                        <i className="bx bx-check"></i> {swapping ? "Menukar..." : "Konfirmasi Tukar"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ========================================================
                    MODAL: CONFIRM DELETE / KOSONGKAN SLOT
                   ======================================================== */}
                {show_delete_confirm && delete_target_slot && (
                    <div className="pc-modal-overlay" onClick={() => this.setState({ show_delete_confirm: false })}>
                        <div className="pc-modal-content pc-modal-sm pc-modal-structured" onClick={e => e.stopPropagation()}>
                            <div className="pc-modal-header-custom">
                                <h4 style={{ color: '#dc2626' }}><i className="bx bx-trash" style={{ color: '#dc2626' }}></i> Kosongkan Slot?</h4>
                                <button className="pc-modal-close-btn" onClick={() => this.setState({ show_delete_confirm: false })}>×</button>
                            </div>
                            <div className="pc-modal-body">
                                <p style={{ fontSize: 13, color: '#475569', margin: '0 0 14px' }}>
                                    Apakah Anda yakin ingin mengosongkan slot jadwal ini?
                                </p>
                                <div className="pc-delete-slot-summary" style={{ margin: 0 }}>
                                    <strong>{delete_target_slot.mapel_nama || "Mata Pelajaran"}</strong>
                                    <div>Guru: {delete_target_slot.guru_nama || "-"}</div>
                                    <small>{this.renderHariLabel(delete_target_slot.hari)}, Jam ke-{delete_target_slot.jam_ke} • Kelas {delete_target_slot.rombel_nama || selected_rombel}</small>
                                </div>
                            </div>
                            <div className="pc-modal-footer-custom pc-modal-actions" style={{ justifyContent: 'flex-end' }}>
                                <div className="pc-modal-footer-right" style={{ width: '100%', justifyContent: 'flex-end' }}>
                                    <button className="pc-btn pc-btn-ghost" onClick={() => this.setState({ show_delete_confirm: false })}>
                                        Batal
                                    </button>
                                    <button
                                        className="pc-btn pc-btn-danger"
                                        disabled={deleting}
                                        onClick={() => this.handleExecuteDelete()}
                                    >
                                        <i className="bx bx-trash"></i> {deleting ? "Menghapus..." : "Ya, Kosongkan Slot"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
